import { User } from "src/auth/types/interfaces";

export enum CARGO_STAGES {
  STAGE1 = "STAGE1",
  STAGE2 = "STAGE2",
  STAGE3 = "STAGE3",
}

export interface CargoClaimAdditionalFields {
  user?: User | null;
  amazonClaimReferenceId: string;
  claimNumber?: string;
  incidentDate?: string;
}
